import React from 'react'
import ContactForm from './ContactForm'
import Sponsors from '../../components/common/Sponsors'

const SectionContact = () => {
  return (
    <>
    <ContactForm/>
    <Sponsors/>
    </>
  )
}

export default SectionContact
